import { useMemo, useState, useCallback } from 'react';
import {
  addIntervalFields,
  getDefaultFilters,
  mapFieldsToFilterBuilder,
  saveFiltersByColumn
} from '../utils';
import { useRouteFields } from 'react/queries/fields/RouteFields';

function useRouteFilter() {
  const FILTER_NAME = 'SpeedAssignmentRoute';
  const [filters, setFilters] = useState();
  const routeFieldsQuery = useRouteFields();
  let defaultSelected;
  let defaultValues ;
  try {
    const defaultFilters = getDefaultFilters(FILTER_NAME);
    defaultSelected = defaultFilters?.defaultSelected;
    defaultValues = defaultFilters?.defaultValues;
  } catch (error) {
    console.error('Error getting default filters:', error);
  }

  const handleFilterSubmit = useCallback((values) => {
    try {
      setFilters(values);
      saveFiltersByColumn(FILTER_NAME, values);
    } catch (error) {
      console.error('Error saving filters:', error);
    }
  }, []);

  const filterBuilderFields = useMemo(() => {
    try {
      const fieldsData = routeFieldsQuery.data || [];

      const fieldsMapped = fieldsData.map((field) =>
        mapFieldsToFilterBuilder(field, fieldsData)
      );

      const allFields = addIntervalFields(fieldsMapped);
      return allFields;
    } catch (error) {
      console.error('Error building filter fields:', error);
      return [];
    }
  }, [routeFieldsQuery.data]);

  return {
    filters,
    defaultSelected,
    defaultValues,
    handleFilterSubmit,
    filterBuilderFields,
    routeFieldsQuery
  };
}

export default useRouteFilter;
